import React from 'react'
import MaterialSymbol from '../material-symbol'

const GolfCourse = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="golf_course" {...props} />
))

GolfCourse.displayName = 'GolfCourse'

export default GolfCourse
